<template>
  <div class="decor pb-6"
       :class="{'isNewDecor':decor.isTop || decor.isNew}">
    <div @click="focusDecor" class="image">
      <div v-if="decor.isNew" class="new__balloon  flex float-right justify-center text-center"><p
        class="transform -rotate-45">New</p></div>
      <div v-if="decor.isTop" class="new__balloon flex float-right justify-center text-center"><p
        class="transform -rotate-45">Top</p></div>
      <img v-if="decor.thumbnail" :src="decor.thumbnail" alt="thumbnail">
      <img v-else src="../../../assets/media/NoImage.png"
           class="classen__rounded border-classen__secondary border"
           alt="no image">
    </div>
    <div v-if="displayDelete" @click="$emit('delete')" class="delete relative"><i
      class="fa fa-trash"></i></div>
    <c-selection v-if="displayQuick" class="w-8/10 selection poi"
                 :decor="decor"
                 :mode="'decor'"
                 :selectedSelection="selectedSelection"
                 @changed-selection="changeSelected"
                 @addSelectionToProduct="addToSelection"
                 @removeSelectionFromProduct="removeFromSelection"/>
    <div @click="focusDecor" :class="{'raise':displayQuick, 'raiseDelete':displayDelete}"
         class="mb-1 grid grid-cols-10">
      <p
        class="font-bold name col-span-7 text-left overflow-hidden whitespace-nowrap overflow-ellipsis">
        {{ decor.name }} </p>
      <p class="col-start-8 justify-items-end col-span-3 overflow-hidden text-right">
        {{ decor.number ? decor.number : decor.id }}</p>
    </div>

  </div>
</template>

<script>
import EventBus from "../../../services/EventBus";
import getTranslation from "../../../mixins/getTranslation";
import SelectionDropdown from "../SelectionDropdown";

export default {
  name: "DecorView",

  mixins: [getTranslation],

  components: {
    'c-selection': SelectionDropdown
  },

  props: {
    decor: {required: true, type: Object},
    displayQuick: {required: false, type: Boolean, default: true},
    selectedSelection: {required: false, type: Object},
    displayDelete: {required: false, type: Boolean, default: false},
  },

  data() {
    return {
      decorSelection: {id: -1, name: "Set default selection"}
    }
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {},

  methods: {
    changeSelected(selection) {
      this.decorSelection = selection;
    },

    focusDecor(e) {
      let decor = JSON.parse(JSON.stringify(this.decor));
      EventBus.fire('set-active_decor', decor, this.decorSelection)
    },

    addToSelection(selection = null) {
      if (this.selectedSelection.id === -1 && selection === null) {
        return
      }

      if (selection === null) {
        this.$dashboardStore.dispatch('addDecorToSelection', {
          decorId: this.decor.id,
          selectionId: this.selectedSelection.id,
        }).then(() => {
          this.decor.selections.push(this.selectedSelection)
        });
      } else {
        this.$dashboardStore.dispatch('addDecorToSelection', {
          decorId: this.decor.id,
          selectionId: selection.id,
        }).then(() => {
          this.decor.selections.push(selection)
        });
      }
    },

    removeFromSelection(selection) {
      this.$dashboardStore.dispatch('removeDecorFromSelection', {
        decorId: this.decor.id,
        selectionId: selection.id,
      }).then(() => {
        this.decor.selections = this.decor.selections.filter((selectionItem) => {
          return selectionItem.id !== selection.id
        });
      });

      EventBus.fire('clear-selected-selection');
    },
  }
}
</script>

<style scoped>
.decor {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.decor:hover {
  cursor: pointer;
}

.isNewDecor {
  margin-top: -40px;
}

img {
  width: 300px;
  height: 195px;
  object-fit: none;
  border-radius: 35px 0 35px 0;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* number of lines to show */
}

.selection {
  position: relative;
  top: -55px;
}

.raise {
  margin-top: -42px;
}

.raiseDelete {
  margin-top: -32px;
}

.delete {
  transform: translate(5px, -35px);
  height: 30px;
  width: 30px;
  color: white;
  border-radius: 20px;
  line-height: 30px;
  text-align: center;
  background-color: var(--primary)
}
</style>
